import { atom } from 'jotai';
import { defineOnceAtom } from '../util';
export const $EnterTraffic = defineOnceAtom();
$EnterTraffic.debugLabel = '$EnterTraffic';
export const $CurrentTraffic = atom({});
$CurrentTraffic.debugLabel = '$CurrentTraffic';
